import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders, HttpParams, HttpEvent } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { blobToFile, delay, isNotNullAndUndefined, isNullOrUndefined } from '../../helpers/utils';
import { map } from 'rxjs/operators';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { AttachmentInfo } from 'src/app/model/analyse-credit';
import { MxBaseRestService } from 'mx-commons';

@Injectable()
export class UploadService {

	private baseUrl = environment.baseUrl + environment.baseApi;

	constructor(
		private readonly http: HttpClient,
		private readonly ng2ImgMaxService: Ng2ImgMaxService,
		private readonly restService: MxBaseRestService
	) { }

	public async upload(url: string, file: File, params?: HttpParams): Promise<AttachmentInfo> {
		// create a new multipart-form for every file
		const formData: FormData = new FormData();
		formData.append('file', file, file.name);

		const token: string = localStorage.getItem('token');
		const headers = new HttpHeaders({ Authorization: `Bearer  ${token}` });
		// create a http-post request and pass the form
		// tell it to report the upload progress
		const request = new HttpRequest<FormData>('POST', this.baseUrl + url, formData, { reportProgress: true, headers: headers, params: params });
		// send the http-request and subscribe for progress-updates
		const response = await this.http.request(request).toPromise()
	
		return response as unknown as AttachmentInfo
	}

	public async uploadMultiple(url: string, files: Array<File>): Promise<Array<AttachmentInfo>> {

		const formData: FormData = new FormData();

		files.forEach(function (file, i) {
			formData.append('file', file, file.name);
		});
		const token: string = localStorage.getItem('token');
		const headers = new HttpHeaders({ Authorization: `Bearer  ${token}` });
		// create a http-post request and pass the form
		// tell it to report the upload progress
		const request = new HttpRequest<FormData>('POST', this.baseUrl + url, formData, { reportProgress: true, headers: headers });
		let response: Array<AttachmentInfo>
		// send the http-request and subscribe for progress-updates
		this.http.request(request).subscribe(event => {
			if (event instanceof HttpResponse) {
				// Close the progress-stream if we get an answer form the API
				// The upload is complete
				if (isNotNullAndUndefined(event.body)) {
					response = event.body as Array<AttachmentInfo>
				}
			}
		});

		return response
	}

	download(url: string, options: any): Observable<IResponseDownload> {
		const token: string = localStorage.getItem('token');
		if (isNullOrUndefined(options)) {
			options = {};
		}

		if (token)
			options.headers = new HttpHeaders({ Authorization: `Bearer  ${token}`});
		else
			options.headers = new HttpHeaders();
			
		options.observe = 'response' as 'body';
		return this.http.get<any>(this.baseUrl + url, options).pipe(map((response: any) => {
			const contentDispositionHeader = response.headers.get('Content-Disposition');
			let name = 'attachment';
			if (contentDispositionHeader !== null) {
				name = contentDispositionHeader.split(';')[1].trim().split('=')[1].replace(/"/g, '');
			}
			return { blob: response.body, fileName: name };
		}));
	}

	checkImageAndResize(file: File, width: number = 1000, length: number = 1000): Observable<File> {
		const result$ = new Subject<File>();

		const pattern = 'image-*/';
		if (!file.type.match(pattern)) {
			delay(100).then(() => {
				result$.next(file);
				result$.complete();
			});
			return result$.asObservable();
		}

		this.ng2ImgMaxService.resizeImage(file, width, length).subscribe(blob => {
			result$.next(blobToFile(blob, blob.name));
			result$.complete();
		}, (error: any) => {
			result$.error(error);
		});

		return result$.asObservable();
	}

	public delete(url: string, params?: HttpParams) {
		const token: string = localStorage.getItem('token');
		const headers = new HttpHeaders({ Authorization: `Bearer  ${token}` });
		// create a http-post request and pass the form
		// tell it to report the upload progress
		const request = new HttpRequest<any>('DELETE', this.baseUrl + url, null, { reportProgress: true, headers: headers, params: params });

		this.http.request(request).subscribe(event => {
			if (event.type === HttpEventType.UploadProgress) {
				null;
			} else if (event instanceof HttpResponse) {
				null;
			}
		}, (error: any) => {
			return error;
		});
	}

}

export interface IUploadProgressResult {
	progress: Observable<number>;
	resultId: Observable<string>;
}

export interface IResponseDownload {
	blob: Blob;
	fileName: string;
}
